{
  "title": "Informes Programados",
  "subtitle": "Configure informes de correo electrónico automatizados para su FBO",
  "status": {
    "notConfigured": "No Configurado",
    "disabled": "Desactivado",
    "enabled": "Activado"
  },
  "lastRun": {
    "never": "Nunca",
    "justNow": "Ahora mismo",
    "minutesAgo": "Hace {{count}} min",
    "hoursAgo": "Hace {{count}} hr"
  },
  "occupancy": {
    "title": "Informe de Ocupación Nocturna",
    "subtitle": "Instantánea diaria de aeronaves",
    "description": "Envía automáticamente una instantánea de todas las aeronaves en hangares y rampas a una hora programada cada noche."
  },
  "labels": {
    "locations": "Ubicaciones",
    "hangars": "hangares",
    "ramps": "rampas",
    "selected": "seleccionados",
    "snapshotTime": "Hora del Informe",
    "recipients": "Destinatarios",
    "emailsConfigured": "correo(s) configurado(s)",
    "lastRun": "Última Ejecución",
    "nextRun": "Próxima Ejecución",
    "error": "Error:"
  },
  "buttons": {
    "configure": "Configurar",
    "setUp": "Configurar Informe",
    "disable": "Desactivar"
  },
  "disableDialog": {
    "title": "Desactivar Informe",
    "message": "¿Está seguro de que desea desactivar este informe programado? Puede volver a activarlo más tarde.",
    "confirm": "Desactivar Informe"
  },
  "configDialog": {
    "titleNew": "Configurar Informe de Ocupación",
    "titleEdit": "Configurar Informe de Ocupación",
    "testEmailSent": "¡Correo de prueba enviado! Revise su bandeja de entrada.",
    "fields": {
      "enableReport": "Activar informe programado",
      "hangars": "Hangares",
      "selectHangars": "Seleccionar hangares...",
      "hangarsHelp": "Seleccione los hangares para incluir en el informe",
      "ramps": "Rampas",
      "selectRamps": "Seleccionar rampas...",
      "rampsHelp": "Seleccione las rampas para incluir en el informe",
      "noRampsAvailable": "No hay rampas disponibles",
      "snapshotTime": "Hora del Informe",
      "snapshotTimeHelp": "Cuándo capturar y enviar el informe",
      "recipients": "Destinatarios de Correo",
      "recipientsHelp": "Lista de direcciones de correo separadas por comas",
      "fileFormat": "Formato de Adjunto",
      "fileFormatHelp": "CSV se abre directamente en Excel. TSV usa valores separados por tabulaciones.",
      "timezone": "Zona Horaria"
    },
    "buttons": {
      "sendTest": "Enviar Correo de Prueba"
    },
    "errors": {
      "noLocationsSelected": "Por favor seleccione al menos un hangar o rampa",
      "noRecipients": "Por favor ingrese al menos una dirección de correo",
      "invalidEmails": "Dirección(es) de correo inválida(s): {{emails}}",
      "noSnapshotTime": "Por favor establezca una hora del informe",
      "saveFailed": "Error al guardar la configuración del informe. Por favor intente de nuevo.",
      "testFailed": "Error al enviar correo de prueba. Por favor intente de nuevo."
    }
  }
}
